import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';

class SkeletonWrapper extends Component {
  cloneWithSkeleton=()=>{
    let childarr = React.Children.toArray(this.props.children);
    for(let i = 0; i < childarr.length; i++){
      if(childarr[i].props.children){
        //Child has children
        let subChildren = React.Children.toArray(childarr[i].props.children);
        subChildren = subChildren.map(o=>o.props ? <Skeleton style={o.props.style} className={o.props.className}/> : <Skeleton />)
        childarr[i] = React.cloneElement(childarr[i], {children: subChildren})
      } else{
        //Child has no children
        let dimensionObj = this.getDimensionObj(childarr[i]);
        childarr[i] = React.cloneElement(childarr[i], {children: (dimensionObj.height || dimensionObj.width) ? <Skeleton height={dimensionObj.height} width={dimensionObj.width}/> : <Skeleton/>})
      }
    }
    return childarr;
  }
  getDimensionObj=(child)=>{
    if(child.props && child.props.style){
      let height = child.props.style.height || null;
      let width = child.props.style.width || null;
      if(~height.indexOf('px')) height = parseInt(height.substring(0, height.indexOf('px')));
      if(~width.indexOf('px')) width = parseInt(width.substring(0, width.indexOf('px')));
      return {height, width};
    }
    return {};
  }
  render() {
    const {loading} = this.props;
    return (
      <React.Fragment>
      {
        loading ? this.cloneWithSkeleton() : this.props.children
      }
      </React.Fragment>
    )
  }
}
SkeletonWrapper.defaultProps={
  loading: true
}
export default SkeletonWrapper;